"use strict";

jQuery(document).ready(function ($) {
  $('.unit-iframe__header .btn').on('click', function () {
    var selected = $(this);
    var target = selected.data('target');
    $('.unit-iframe__header .btn').removeClass('active');
    selected.addClass('active');
    $('.unit-iframe__tab').removeClass('active');
    $('#' + target).addClass('active');
    sendHeight('#' + target);
  });
  sendHeight('#qualification-overview');
});
function sendHeight(tabContent) {
  // Get references to elements
  var iframeTabsHeader = document.querySelector('.unit-iframe__header');
  var iframeTabContent = document.querySelector(tabContent);
  if (iframeTabsHeader && iframeTabContent) {
    var heightIframeTabs = iframeTabsHeader.clientHeight;
    var heightIframeTabContent = iframeTabContent.clientHeight;
    var heightIframeTotal = heightIframeTabs + heightIframeTabContent;

    // console.log('Tab content' + tabContent);
    // console.log('Tab heightIframeTabs' + heightIframeTabs);
    // console.log('Tab heightIframeTabContent' + heightIframeTabContent);
    // console.log('Tab heightIframeTotal' + heightIframeTotal);

    // I noticed that sometimes undefined
    // was sent as the height to the parent,
    // so check for it before trying
    if (heightIframeTotal) {
      window.parent.postMessage({
        heightIframeContent: heightIframeTotal
      }, "*");
    }
  }
}